// extracted by mini-css-extract-plugin
export default {"title__container":"Base_title__container__QGhRl","root--hidden":"Base_root--hidden__uIYgB","root__container":"Base_root__container__HF+8g","title":"Base_title__nR5ci"};